// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Thank you page */

.thankyou_card__iKWTR {
  width: 100%;
  max-width: 560px;
  align-self: center;
  align-items: center;
  text-align: center;
}

.thankyou_successCircle__Osnx5 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: var(--radius-full);
  background: var(--surface-success);
  color: var(--success);
}

.thankyou_copy__eNcrE {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  max-width: 52ch;
}

.thankyou_support__yjlxI {
  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--text-secondary);
  max-width: 52ch;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/thankyou.module.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB","sourcesContent":["/* Thank you page */\n\n.card {\n  width: 100%;\n  max-width: 560px;\n  align-self: center;\n  align-items: center;\n  text-align: center;\n}\n\n.successCircle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 64px;\n  height: 64px;\n  border-radius: var(--radius-full);\n  background: var(--surface-success);\n  color: var(--success);\n}\n\n.copy {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n  max-width: 52ch;\n}\n\n.support {\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: var(--text-secondary);\n  max-width: 52ch;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `thankyou_card__iKWTR`,
	"successCircle": `thankyou_successCircle__Osnx5`,
	"copy": `thankyou_copy__eNcrE`,
	"support": `thankyou_support__yjlxI`
};
export default ___CSS_LOADER_EXPORT___;
